import React, {FC, MutableRefObject} from 'react'
import {VirtualizedUserList} from 'widgets/virtualizedUserList'

export const FavoritesPage: FC<{wrapperRef: MutableRefObject<HTMLDivElement | null>}> = ({wrapperRef}) => {

  return (
    <VirtualizedUserList isPeoplePage={false} ref={wrapperRef} />
  )
}
